import { APIS } from '@/constants';
import axios from 'axios';

const gaiaRest = {
  /**
   * Get node information
   * @returns {AxiosPromise}
   * @note SDK 0.50: Path changed from /node_info to /cosmos/base/tendermint/v1beta1/node_info
   */
  requestNodeInfo() {
    return axios({
      url: '',
      method: 'get',
      baseURL: APIS.HTTP.NODE_INFO,
    });
  },
};

export default gaiaRest;
